import { connector } from "utils/common/connector";

const controller = "referralCategory";

// ---------------------------------------------
// GET CATEGORIES BY COMPANY
// ---------------------------------------------
export const getCustomerCategoriesService = async (params) => {
  let reply;

  try {
    const response = await connector.get(
      controller,
      "getCategoriesByCompany",
      params,
    );

    reply = {
      categories: response?.categories ?? response ?? [],
    };
  } catch (error) {
    console.log(error);
    reply = {
      categories: [],
    };
  }

  return reply;
};

// ---------------------------------------------
// GET CATEGORIES BY PAGINATION
// ---------------------------------------------
export const getCustomerCategoriesByPaginationService = async (params) => {
  let reply;

  try {
    const response = await connector.get(
      controller,
      "getCategoriesByPagination",
      params,
    );

    reply = {
      categories: response?.categories ?? response ?? [],
      totalRecords: response?.totalRecords ?? 0,
    };
  } catch (error) {
    console.log(error);
    reply = {
      categories: [],
      totalRecords: 0,
    };
  }

  return reply;
};

// ---------------------------------------------
// CREATE CUSTOMER CATEGORY
// ---------------------------------------------
export const createCustomerCategoryService = async (params) => {
  let reply;

  try {
    const response = await connector.post(controller, "newCategory", params);

    reply = response ?? { success: false };
  } catch (error) {
    console.log(error);
    reply = { success: false };
  }

  return reply;
};

// ---------------------------------------------
// UPDATE CUSTOMER CATEGORY
// ---------------------------------------------
export const updateCustomerCategoryService = async (params) => {
  let reply;

  try {
    const response = await connector.post(controller, "updateCategory", params);

    reply = response ?? { success: false };
  } catch (error) {
    console.log(error);
    reply = { success: false };
  }

  return reply;
};
